export class AzureVnetConnectivityConfig {
    'region';
    'vnetName';
    'resourceGroup';
    'subnetNames';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "vnetName",
            "baseName": "vnetName",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceGroup",
            "baseName": "resourceGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetNames",
            "baseName": "subnetNames",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureVnetConnectivityConfig.attributeTypeMap;
    }
    constructor() {
    }
}
